// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__398xv","filesListContainer":"PosDisputesFiles_filesListContainer__lKKBS","filesButton":"PosDisputesFiles_filesButton__1SRSz"};